import React from 'react';
import { motion } from 'framer-motion';
import { QuoteForm } from './QuoteForm';
export function HeroSection() {
  return <section className="relative pt-28 pb-0 lg:pt-32 overflow-hidden bg-slate-900" id="hero" data-id="element-103">
      {/* Background */}
      <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-104"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900/90" data-id="element-105"></div>
      <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/3 w-[800px] h-[800px] bg-primary/20 rounded-full blur-[120px] pointer-events-none" data-id="element-106"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-12" data-id="element-108">
          {/* Left Content */}
          <motion.div className="w-full lg:w-[55%] pt-8 lg:pt-16 pb-16 lg:pb-24" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-109">
            {/* Label with line */}
            <div className="flex items-center gap-4 mb-8" data-id="element-110">
              <div className="w-10 h-[2px] bg-primary" data-id="element-111"></div>
              <span className="text-primary text-xs font-bold uppercase tracking-[0.2em]" data-id="element-112">
                Telecom Expense Management
              </span>
            </div>

            {/* Headline */}
            <h1 className="text-4xl md:text-5xl lg:text-[3.5rem] font-extrabold text-white leading-[1.1] mb-6 tracking-tight" data-id="element-113">
              Your Telecom Bill Is{' '}
              <em className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-primary not-italic font-extrabold italic" data-id="element-114">
                Overcharging You.
              </em>
            </h1>

            {/* Description */}
            <p className="text-lg text-slate-400 leading-relaxed mb-10 max-w-xl" data-id="element-115">
              Most businesses overpay for telecom by 20–40%. Ambient Telecom
              audits every line, every contract, and every invoice — then
              eliminates the waste. Average client saves{' '}
              <span className="text-primary font-semibold" data-id="element-116">$84,000/year</span>.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-start gap-4 mb-12" data-id="element-117">
              <a href="#quote" className="w-full sm:w-auto bg-primary hover:bg-primary-dark text-white px-8 py-4 rounded-full font-bold text-base transition-colors shadow-lg shadow-primary/20 inline-flex items-center justify-center gap-2" data-id="element-118">
                <span className="text-lg" data-id="element-119">⊙</span>
                Get My Free Audit
              </a>
              <a href="#featured-services" className="w-full sm:w-auto border-2 border-slate-600 hover:border-slate-400 text-white px-8 py-4 rounded-full font-bold text-base transition-colors inline-flex items-center justify-center" data-id="element-120">
                See How It Works
              </a>
            </div>

            {/* Divider */}
            <div className="border-t border-slate-700/60 pt-8" data-id="element-121">
              {/* Stats Row */}
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-6" data-id="element-122">
                {[{
                value: '34%',
                label: 'Avg. savings'
              }, {
                value: '$2.1M',
                label: 'Recovered in 2024'
              }, {
                value: '312',
                label: 'Clients served'
              }, {
                value: '60d',
                label: 'Time to savings'
              }].map((stat, i) => <motion.div key={i} initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.4,
                delay: 0.4 + i * 0.1
              }} data-id="element-123">
                    <div className="text-2xl md:text-3xl font-extrabold text-white tracking-tight" data-id="element-124">
                      {stat.value}
                    </div>
                    <div className="text-xs text-slate-500 font-medium mt-1 uppercase tracking-wider" data-id="element-125">
                      {stat.label}
                    </div>
                  </motion.div>)}
              </div>
            </div>
          </motion.div>

          {/* Right Content - Form */}
          <motion.div className="w-full lg:w-[45%] lg:relative" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-126">
            <div className="lg:sticky lg:top-24 pb-12 lg:pb-0 lg:-mb-16" data-id="element-127">
              <QuoteForm data-id="element-128" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}